  window.PBFCM_Minicart = window.PBFCM_Minicart || {};

  if (!window.PBFCM_Minicart.giftProgress) {
    var __pdpOverride = (typeof window !== 'undefined' && window.__pdpDiscountOverride) || null;
    var __pdpOverrideActive = !!(__pdpOverride
      && typeof __pdpOverride.discountPercent === 'number'
      && Number.isFinite(__pdpOverride.discountPercent));
    var __giftBfcmModeEnabled = __pdpOverrideActive ? true : window.FDGiftProgressConfig.bfcmModeEnabled;
    var __giftBfcmDiscountPercent = __pdpOverrideActive ? __pdpOverride.discountPercent : window.FDGiftProgressConfig.bfcmDiscountPercent;
    var __giftBfcmDiscountMultiplier = (100 - __giftBfcmDiscountPercent) / 100;
    var __giftProgressSvgLock = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M3.33859 10.4231C3.127 10.4231 2.94592 10.3478 2.79534 10.1971C2.64467 10.0465 2.56934 9.86537 2.56934 9.65387V5.31537C2.56934 5.10387 2.64467 4.92279 2.79534 4.77212C2.94592 4.62146 3.127 4.54612 3.33859 4.54612H4.05396V3.56437C4.05396 3.01987 4.24267 2.55891 4.62009 2.1815C4.99742 1.80408 5.45742 1.61537 6.00009 1.61537C6.54275 1.61537 7.00275 1.80408 7.38009 2.1815C7.7575 2.55891 7.94621 3.01987 7.94621 3.56437V4.54612H8.66159C8.87317 4.54612 9.05425 4.62146 9.20484 4.77212C9.3555 4.92279 9.43084 5.10387 9.43084 5.31537V9.65387C9.43084 9.86537 9.3555 10.0465 9.20484 10.1971C9.05425 10.3478 8.87317 10.4231 8.66159 10.4231H3.33859ZM5.99934 8.2115C6.20359 8.2115 6.37592 8.14158 6.51634 8.00175C6.65675 7.86183 6.72696 7.68971 6.72696 7.48537C6.72696 7.28104 6.65704 7.10866 6.51721 6.96825C6.37729 6.82791 6.20517 6.75775 6.00084 6.75775C5.79659 6.75775 5.62425 6.82766 5.48384 6.9675C5.34342 7.10741 5.27321 7.2795 5.27321 7.48375C5.27321 7.68808 5.34313 7.86046 5.48296 8.00087C5.62288 8.14129 5.795 8.2115 5.99934 8.2115ZM4.51546 4.54612H7.48471V3.56037C7.48471 3.14962 7.34046 2.79971 7.05196 2.51062C6.76346 2.22145 6.41313 2.07687 6.00096 2.07687C5.58888 2.07687 5.23825 2.22141 4.94909 2.5105C4.66 2.79958 4.51546 3.15058 4.51546 3.5635V4.54612Z" fill="#2C3D50"/></svg>';
    var __giftProgressSvgCheck = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4.77492 8.82688L2.10767 6.15963L2.64217 5.625L4.77492 7.75775L9.35767 3.175L9.89217 3.70963L4.77492 8.82688Z" fill="white"/></svg>';
    var __giftProgressFallbackGiftValue = window.FDGiftProgressConfig.fallbackGiftValue;
    var __giftInfoIconUrl = window.FDGiftProgressConfig.infoIconUrl;
    var __giftProgressSvgSwap = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5.333 4.667h8M11.333 2l2 2.667-2 2.666M10.667 11.333h-8M4.667 14l-2-2.667 2-2.666" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var __giftProgressSvgBadge = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M2.5 4.5h7v5.2a.8.8 0 0 1-.8.8h-5.4a.8.8 0 0 1-.8-.8V4.5Z" stroke="#fff" stroke-width="1.1"/><path d="M2.3 4.5h7.4l-.7-1.6H3l-.7 1.6Z" stroke="#fff" stroke-width="1.1"/><path d="M6 2.4v7.6" stroke="#fff" stroke-width="1.1"/></svg>';

    window.PBFCM_Minicart.giftProgress = {
      instances: [],
      _listenersBound: false,
      _giftVariantCache: {},
      _giftProductCache: {},
      statusIncomplete: window.FDGiftProgressConfig.statusIncomplete,
      statusComplete: window.FDGiftProgressConfig.statusComplete,
      chooseGiftLabel:
        (window.FDGiftProgressConfig.chooseGiftLabel && String(window.FDGiftProgressConfig.chooseGiftLabel).trim()) ||
        'Pick your FREE gift',
      swapGiftHeading: window.FDGiftProgressConfig.swapGiftHeading || 'Choose your gift',
      selectedGiftLabel: window.FDGiftProgressConfig.selectedGiftLabel || 'Selected',
      bfcmModeEnabled: __giftBfcmModeEnabled,
      bfcmDiscountPercent: __giftBfcmDiscountPercent,
      bfcmDiscountMultiplier: __giftBfcmDiscountMultiplier,

      isAbTire(root) {
        return !!root;
      },

      isPlaceholderGiftTitle(title) {
        if (!title) return true;
        var normalized = String(title).trim().toLowerCase();
        return normalized === 'default title' || normalized === 'default';
      },

      shortGiftDescription(text) {
        var clean = this.stripHtml(text || '').replace(/\s+/g, ' ').trim();
        if (!clean) return '';
        clean = clean.replace(/^how it works:\s*/i, '');
        if (!clean) return '';
        if (clean.length <= 80) return clean;
        var cut = clean.slice(0, 80);
        var space = cut.lastIndexOf(' ');
        return (space > 36 ? cut.slice(0, space) : cut) + '…';
      },

      rawProductDescription(product) {
        if (!product) return '';
        var html = (product.description && String(product.description).trim())
          || (product.body_html && String(product.body_html).trim())
          || '';
        return html;
      },

      slugifyGiftTitle(title) {
        return String(title || '')
          .toLowerCase()
          .replace(/['’™]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/-+/g, '-')
          .replace(/^-|-$/g, '');
      },

      findCartItemByVariant(cart, variantId) {
        if (!cart || !cart.items || !variantId) return null;
        var id = String(variantId);
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if (String(item.variant_id || item.id) === id) return item;
        }
        return null;
      },

      applyCartItemToCard(card, item) {
        if (!card || !item) return card;
        if (item.handle) card.handle = item.handle;
        if (item.product_title && !this.isPlaceholderGiftTitle(item.product_title)) {
          card.title = item.product_title;
        }
        var image = item.featured_image && (item.featured_image.url || item.featured_image.src)
          ? (item.featured_image.url || item.featured_image.src)
          : item.image;
        if (image) card.imageUrl = this.sizeGiftImageUrl(image);
        var desc = this.shortGiftDescription(item.product_description || '');
        if (desc) card.description = desc;
        return card;
      },

      hydrateGiftCard(inst, card) {
        if (!card) return card;
        this.applyCartItemToCard(card, this.findCartItemByVariant(inst && inst.lastCart, card.variantId));
        return card;
      },

      waitForStorefront(maxMs) {
        var deadline = Date.now() + (maxMs || 2000);
        return new Promise(function (resolve) {
          function check() {
            if (window.Storefront && typeof window.Storefront.productsByIds === 'function') {
              resolve(true);
              return;
            }
            if (Date.now() >= deadline) {
              resolve(false);
              return;
            }
            setTimeout(check, 50);
          }
          check();
        });
      },

      readAbTiersConfig(configEl) {
        if (!configEl) return [];
        try {
          var rawText = (configEl.textContent || '').trim();
          var parsed = JSON.parse(rawText || '[]');
          if (!Array.isArray(parsed)) {
            parsed = parsed && parsed.threshold ? [parsed] : [];
          }
          var seen = {};
          return parsed
            .map(function (tier) {
              var threshold = Number(tier.threshold);
              var giftValue = Number(tier.giftValue);
              if (!Number.isFinite(threshold) || threshold <= 0) return null;
              var thresholdCents = Math.round(threshold * 100);
              if (seen[thresholdCents]) return null;
              seen[thresholdCents] = true;
              var giftVariant = tier.giftVariant || tier.gift_variant || null;
              if (giftVariant && typeof giftVariant === 'object') {
                giftVariant = giftVariant.id || giftVariant.gid || giftVariant.value || null;
              }
              return {
                thresholdCents: thresholdCents,
                giftValue: Number.isFinite(giftValue) && giftValue > 0 ? giftValue : 25,
                giftVariant: giftVariant
              };
            })
            .filter(Boolean)
            .sort(function (a, b) { return a.thresholdCents - b.thresholdCents; });
        } catch (e) {
          console.error('PBFCM gift progress: invalid tiers config', e);
          return [];
        }
      },

      createInstance(root) {
        var configEl = root.querySelector('[data-gift-tiers-config]');
        var abTiers = this.readAbTiersConfig(configEl);
        var themeThresholdCents = parseInt(root.getAttribute('data-threshold-cents') || '0', 10) || 0;
        if (!abTiers.length) {
          abTiers = [{ thresholdCents: themeThresholdCents, giftValue: __giftProgressFallbackGiftValue }];
        }
        // Legacy bar is single-threshold ($75 theme default / first tier).
        // inst.threshold was wrongly set to the max tier ($94), so $92.84 carts
        // showed "$1.16 away" instead of unlocked.
        var legacyThresholdCents = abTiers[0].thresholdCents || themeThresholdCents;
        var maxThresholdCents = abTiers[abTiers.length - 1].thresholdCents;
        root.classList.toggle('is-single-tier', abTiers.length <= 1);

        return {
          root: root,
          layout: root.getAttribute('data-layout') || 'minicart',
          instanceId: root.getAttribute('data-instance-id') || 'minicart',
          threshold: maxThresholdCents,
          legacyThreshold: legacyThresholdCents,
          abTiers: abTiers,
          abTiersBuilt: false,
          progressBar: root.querySelector('[data-gift-progress-bar]'),
          statusText: root.querySelector('[data-gift-status]'),
          bottomContainer: root.querySelector('.PBFCM-minicart-gift-progress__bottom'),
          cardContainer: root.querySelector('.PBFCM-minicart-gift-progress__card'),
          barMark: root.querySelector('.PBFCM-minicart-gift-progress__bar-mark'),
          tooltip: root.querySelector('[data-gift-tooltip]'),
          tooltipSalePrice: root.querySelector('[data-gift-tooltip-sale]'),
          tooltipOrigPrice: root.querySelector('[data-gift-tooltip-orig]'),
          abToggle: root.querySelector('.PBFCM-minicart-gift-progress__ab-toggle'),
          abFill: root.querySelector('[data-gift-ab-fill]'),
          abBar: root.querySelector('.PBFCM-minicart-gift-progress__ab-bar'),
          abHeadline: root.querySelector('[data-gift-ab-headline]'),
          abTiersHost: root.querySelector('[data-gift-ab-tiers]'),
          abProgress: root.querySelector('.PBFCM-minicart-gift-progress__ab-progress'),
          abTierEls: [],
          abGiftsHost: root.querySelector('[data-gift-ab-gifts]'),
          abGiftsBuilt: false,
          lastSaleCartTotal: 0,
          cachedTierDotRatios: null,
          dotRatiosDirty: false,
          giftCardsVersion: 0,
          renderedGiftCardsVersion: null,
          renderedSaleCartTotal: null,
          lastAbFillWidth: null,
          lastGiftsHtml: null,
          lastHeadline: null,
          lastCart: null,
          swapOpen: false,
          swapOpenKey: '',
          swapBusy: false,
          pendingSwapId: null,
          pendingSwapFromId: '',
          pendingSwapPoolKey: '',
          swapFromId: '',
          swapCards: null,
          swapCardsKey: '',
          groupCards: {},
          groupCardsKey: {},
          _giftActionsBound: false
        };
      },

      // Figma progress bar (329px): $75 lock center ≈ 46.4%, $100 lock center ≈ 87.7%
      FIGMA_TIER_DOT_MIN: 152.5 / 329,
      FIGMA_TIER_DOT_MAX: 288.5 / 329,

      getTierDotRatio(thresholdCents, minThresholdCents, maxThresholdCents) {
        if (!maxThresholdCents || maxThresholdCents <= minThresholdCents) {
          return this.FIGMA_TIER_DOT_MAX;
        }
        var minPos = this.FIGMA_TIER_DOT_MIN;
        var maxPos = this.FIGMA_TIER_DOT_MAX;
        var progress = (thresholdCents - minThresholdCents) / (maxThresholdCents - minThresholdCents);
        progress = Math.max(0, Math.min(1, progress));
        return minPos + progress * (maxPos - minPos);
      },

      // Measure where fill should meet the lock (left edge of the dot).
      // Below threshold the bar grows toward this point; at threshold it snaps to 100%.
      measureTierDotRatio(inst, tierEl) {
        if (!inst.abBar || !tierEl) return null;
        var barRect = inst.abBar.getBoundingClientRect();
        if (!barRect.width) return null;
        var dot = tierEl.querySelector('.PBFCM-minicart-gift-progress__ab-tier-dot');
        if (!dot) return null;
        var dotRect = dot.getBoundingClientRect();
        var lockX = dotRect.left - barRect.left;
        return Math.max(0, Math.min(1, lockX / barRect.width));
      },

      needsTierDotMeasure(inst, saleCartTotal) {
        var max = inst.abTiers[inst.abTiers.length - 1].thresholdCents;
        if (saleCartTotal <= 0 || saleCartTotal >= max) return false;
        return !inst.cachedTierDotRatios || inst.dotRatiosDirty;
      },

      buildTierDotRatios(inst, minThreshold, maxThreshold) {
        if (inst.cachedTierDotRatios && !inst.dotRatiosDirty) {
          return inst.cachedTierDotRatios;
        }
        var self = this;
        var hasMeasurement = false;
        var ratios = inst.abTierEls.map(function (tierEl, index) {
          var measured = self.measureTierDotRatio(inst, tierEl);
          if (measured != null) {
            hasMeasurement = true;
            return measured;
          }
          var tierCents = inst.abTiers[index] ? inst.abTiers[index].thresholdCents : 0;
          return self.getTierDotRatio(tierCents, minThreshold, maxThreshold);
        });

        if (hasMeasurement) {
          inst.cachedTierDotRatios = ratios;
          inst.dotRatiosDirty = false;
          return ratios;
        }

        if (inst.cachedTierDotRatios && inst.cachedTierDotRatios.length === ratios.length) {
          return inst.cachedTierDotRatios;
        }

        return ratios;
      },

      resolveTierDotRatio(tierDotRatios, index, thresholdCents, minThreshold, maxThreshold) {
        if (tierDotRatios && tierDotRatios[index] != null) {
          return tierDotRatios[index];
        }
        return this.getTierDotRatio(thresholdCents, minThreshold, maxThreshold);
      },

      getFillBarRatio(saleCartTotal, tiers, minThreshold, maxThreshold, tierDotRatios) {
        if (!maxThreshold || saleCartTotal <= 0) return 0;

        // Gift unlocked: fill the full track (width: 100%), past the lock icon.
        if (saleCartTotal >= maxThreshold) return 1;

        for (var i = 0; i < tiers.length; i++) {
          var tierCents = tiers[i].thresholdCents;
          if (saleCartTotal < tierCents) {
            var prevCents = i === 0 ? 0 : tiers[i - 1].thresholdCents;
            var prevRatio = i === 0
              ? 0
              : this.resolveTierDotRatio(tierDotRatios, i - 1, prevCents, minThreshold, maxThreshold);
            var dotRatio = this.resolveTierDotRatio(tierDotRatios, i, tierCents, minThreshold, maxThreshold);
            var segmentTotal = tierCents - prevCents;
            if (!segmentTotal) return prevRatio;
            var segmentProgress = Math.max(0, Math.min(1, (saleCartTotal - prevCents) / segmentTotal));
            return prevRatio + segmentProgress * (dotRatio - prevRatio);
          }
        }

        return 1;
      },

      escapeGiftCardAttr(value) {
        return String(value == null ? '' : value)
          .replace(/&/g, '&amp;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;');
      },

      SINGLE_TIER_EDGE_GAP: 10,

      layoutTierColumns(inst) {
        if (!inst.abTiersHost || !inst.abTierEls.length || !inst.abTiers.length) return;

        if (inst.abBar) inst.abBar.style.removeProperty('width');
        if (inst.abTiersHost) inst.abTiersHost.style.removeProperty('width');

        var minThreshold = inst.abTiers[0].thresholdCents;
        var maxThreshold = inst.abTiers[inst.abTiers.length - 1].thresholdCents;
        var isSingleTier = inst.abTiers.length <= 1;
        var edgeGap = this.SINGLE_TIER_EDGE_GAP + 'px';

        inst.abTierEls.forEach(function (tierEl) {
          var tCents = parseInt(tierEl.getAttribute('data-threshold-cents') || '0', 10) || 0;
          var ratio = this.getTierDotRatio(tCents, minThreshold, maxThreshold);
          if (isSingleTier) {
            tierEl.style.removeProperty('left');
            tierEl.style.right = edgeGap;
          } else {
            tierEl.style.removeProperty('right');
            tierEl.style.left = (ratio * 100) + '%';
          }
          tierEl.className = 'PBFCM-minicart-gift-progress__ab-tier';
        }, this);
      },

      parseVariantIdFromGid(giftVariant) {
        if (!giftVariant) return null;
        if (typeof giftVariant === 'object') {
          giftVariant = giftVariant.id || giftVariant.gid || giftVariant.value || null;
        }
        if (!giftVariant) return null;
        var match = String(giftVariant).match(/(\d+)$/);
        return match ? match[1] : null;
      },

      resolveVariantImageUrl(variant, variantId, product) {
        if (variant) {
          if (variant.featured_image && variant.featured_image.src) {
            return variant.featured_image.src;
          }
          if (typeof variant.image === 'string' && variant.image) {
            return variant.image;
          }
        }

        if (product && variantId) {
          var variants = product.variants || [];
          var matched = variants.find(function (entry) {
            return String(entry.id) === String(variantId);
          });
          if (matched) {
            if (matched.featured_image && matched.featured_image.src) {
              return matched.featured_image.src;
            }
            if (typeof matched.image === 'string' && matched.image) {
              return matched.image;
            }
          }

          var imageId = variant && variant.image_id;
          if (imageId && Array.isArray(product.images)) {
            var image = product.images.find(function (entry) {
              return String(entry.id) === String(imageId);
            });
            if (image && image.src) return image.src;
          }

          if (typeof product.featured_image === 'string' && product.featured_image) {
            return product.featured_image;
          }
          if (Array.isArray(product.images) && product.images[0] && product.images[0].src) {
            return product.images[0].src;
          }
        }

        return '';
      },

      GIFT_IMAGE_WIDTH: 180,

      sizeGiftImageUrl(url) {
        if (!url) return url;
        var raw = String(url);
        var isProtocolRelative = raw.indexOf('//') === 0;
        var parsed;
        try {
          parsed = new URL(isProtocolRelative ? 'https:' + raw : raw, window.location.origin);
        } catch (error) {
          return url;
        }
        if (parsed.hostname !== 'cdn.shopify.com' && parsed.pathname.indexOf('/cdn/shop/') !== 0) {
          return url;
        }
        parsed.searchParams.set('width', String(this.GIFT_IMAGE_WIDTH));
        if (isProtocolRelative) return parsed.href.replace(/^https:/, '');
        if (/^[a-z][a-z0-9+.-]*:/i.test(raw)) return parsed.href;
        return parsed.pathname + parsed.search + parsed.hash;
      },

      stripHtml(html) {
        var div = document.createElement('div');
        div.innerHTML = html || '';
        return (div.textContent || '').trim();
      },

      normalizeVariantPayload(json) {
        if (!json || typeof json !== 'object') return null;
        return json.variant || json.product_variant || json;
      },

      async fetchVariantJson(variantId) {
        if (!variantId) return null;
        var cacheKey = String(variantId);
        if (this._giftVariantCache[cacheKey]) {
          return this._giftVariantCache[cacheKey];
        }
        try {
          var response = await fetch('/variants/' + cacheKey + '.json', {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          });
          if (!response.ok) return null;
          var json = await response.json();
          var variant = this.normalizeVariantPayload(json);
          if (!variant || !variant.id) return null;
          this._giftVariantCache[cacheKey] = variant;
          return variant;
        } catch (error) {
          return null;
        }
      },

      async fetchProductForVariant(variant) {
        if (!variant) return null;

        var handle = this.extractHandleFromVariant(variant);
        if (!handle && (variant.name || variant.title)) {
          handle = this.slugifyGiftTitle(variant.name || variant.title);
        }
        if (handle) {
          var productByHandle = await this.fetchProductJson(handle);
          if (productByHandle) return productByHandle;
        }

        var productId = variant.product_id;
        if (!productId) return null;

        if (!window.Storefront || typeof window.Storefront.productsByIds !== 'function') {
          await this.waitForStorefront(2000);
        }

        var cacheKey = 'pid:' + productId;
        if (this._giftProductCache[cacheKey]) {
          return this._giftProductCache[cacheKey];
        }

        if (window.Storefront && typeof window.Storefront.productsByIds === 'function') {
          try {
            var products = await window.Storefront.productsByIds([productId]);
            var storefrontProduct = products && products[0];
            if (storefrontProduct) {
              if (storefrontProduct.handle) {
                var fullProduct = await this.fetchProductJson(storefrontProduct.handle);
                if (fullProduct) {
                  this._giftProductCache[cacheKey] = fullProduct;
                  return fullProduct;
                }
              }

              var minimalProduct = {
                id: productId,
                handle: storefrontProduct.handle || '',
                title: storefrontProduct.title || '',
                body_html: '',
                description: '',
                featured_image: storefrontProduct.featured_image || null,
                images: storefrontProduct.featured_image
                  ? [{ src: storefrontProduct.featured_image }]
                  : [],
                variants: (storefrontProduct.variants || []).map(function (entry) {
                  var id = entry.id;
                  if (typeof window.fromGID === 'function' && String(id).indexOf('gid://') === 0) {
                    id = window.fromGID(id);
                  }
                  return {
                    id: id,
                    title: entry.title,
                    featured_image: null,
                    image: null
                  };
                })
              };
              this._giftProductCache[cacheKey] = minimalProduct;
              return minimalProduct;
            }
          } catch (error) {
            console.warn('PBFCM gift progress: Storefront product lookup failed', productId, error);
          }
        }

        return null;
      },

      async fetchProductJson(handle) {
        if (!handle) return null;
        if (this._giftProductCache[handle]) return this._giftProductCache[handle];
        try {
          var response = await fetch('/products/' + encodeURIComponent(handle) + '.js', {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          });
          if (!response.ok) return null;
          var json = await response.json();
          var product = json && json.product ? json.product : json;
          this._giftProductCache[handle] = product;
          return product;
        } catch (error) {
          return null;
        }
      },

      extractHandleFromVariant(variant) {
        if (!variant) return null;
        if (variant.handle) return variant.handle;
        if (variant.product_handle) return variant.product_handle;
        if (variant.url) {
          var match = String(variant.url).match(/\/products\/([^/?#]+)/);
          if (match) return match[1];
        }
        return null;
      },

      async resolveTierGiftCard(tier, fallback) {
        var base = {
          title: fallback.title || 'Free Gift',
          description: fallback.description || '',
          imageUrl: fallback.imageUrl || '',
          handle: fallback.handle || ''
        };
        var variantId = this.parseVariantIdFromGid(tier.giftVariant);
        if (!variantId) return base;

        var variant = await this.fetchVariantJson(variantId);
        if (!variant) return base;

        var product = await this.fetchProductForVariant(variant);
        var handle = (product && product.handle) || this.extractHandleFromVariant(variant) || base.handle;

        var title = base.title;
        if (product && product.title && !this.isPlaceholderGiftTitle(product.title)) {
          title = product.title;
        } else {
          var variantTitle = variant.name || variant.title;
          if (variantTitle && !this.isPlaceholderGiftTitle(variantTitle)) {
            title = variantTitle;
          }
        }
        if (title.indexOf(' - ') > -1 && !/gift/i.test(title)) {
          title = title.split(' - ')[0];
        }

        if (this.isPlaceholderGiftTitle(title) && base.title && !this.isPlaceholderGiftTitle(base.title)) {
          title = base.title;
        }

        var imageUrl = this.sizeGiftImageUrl(this.resolveVariantImageUrl(variant, variantId, product)) || base.imageUrl;

        var description = this.shortGiftDescription(
          this.rawProductDescription(product) || base.description
        );

        return { title: title, description: description, imageUrl: imageUrl, handle: handle || base.handle };
      },

      realGiftLabel(label) {
        var raw = String(label || '').trim();
        if (!raw) return '';
        return raw.toLowerCase() === 'free gift' ? '' : raw;
      },

      packUnitFromTitle(title) {
        var match = String(title || '').match(/(\d+\s*-?\s*(?:pack|pk))\b/i);
        return match ? match[1].replace(/\s+/g, '-') : '';
      },

      displayGiftTitle(title, quantity) {
        var raw = title || 'Free Gift';
        var qty = quantity >= 2 ? quantity : 1;
        if (qty < 2) return raw;
        var rewritten = String(raw).replace(/(\d+)(\s*-?\s*)(pack|pk)\b/gi, function (_, n, sep, unit) {
          return String(parseInt(n, 10) * qty) + sep + unit;
        });
        return rewritten !== String(raw) ? rewritten : raw + ' ×' + qty;
      },

      displayGiftDescription(desc, title, quantity) {
        var body = this.shortGiftDescription(desc || '');
        var qty = quantity >= 2 ? quantity : 1;
        if (qty < 2) return body;
        var pack = this.packUnitFromTitle(title);
        var prefix = pack ? qty + '× ' + pack : qty + '×';
        if (!body) return prefix;
        if (body.toLowerCase().indexOf(prefix.toLowerCase()) === 0) return body;
        return prefix + ' · ' + body;
      },

      renderGiftCardHtml(card, opts) {
        opts = opts || {};
        var qty = opts.quantity >= 2 ? opts.quantity : 1;
        var explicitTitle = this.realGiftLabel(card.giftLabel);
        var title = explicitTitle || this.displayGiftTitle(card.title, qty);
        var desc = String(card.giftDescription || '').trim()
          ? this.shortGiftDescription(card.giftDescription)
          : this.displayGiftDescription(card.description, card.title, qty);
        var imageHtml = card.imageUrl
          ? '<img src="' + card.imageUrl + '" alt="" loading="lazy" width="60" height="60">'
          : '';
        var badgeHtml = opts.showBadge
          ? '<span class="PBFCM-minicart-gift-progress__ab-gift-badge">' + __giftProgressSvgBadge + '</span>'
          : '';
        var variantId = card.variantId ? String(card.variantId) : '';
        var showFooter = !opts.isChoice;
        var moreInfo = showFooter && card.handle
          ? '<button type="button" class="PBFCM-minicart-gift-progress__ab-gift-action" data-info-modal-open="' +
            this.escapeGiftCardAttr(card.handle) +
            '" aria-label="More info about ' + this.escapeGiftCardAttr(title) + '">' +
            '<img src="' + __giftInfoIconUrl + '" alt="" width="16" height="16">' +
            '<span>More Info</span>' +
            '</button>'
          : '';
        var changeGift = showFooter && opts.swappable
          ? '<button type="button" class="PBFCM-minicart-gift-progress__ab-gift-action" data-gwp-change-gift="' +
            this.escapeGiftCardAttr(variantId) +
            '"' +
            (opts.poolKey
              ? ' data-gwp-swap-pool="' + this.escapeGiftCardAttr(opts.poolKey) + '"'
              : '') +
            '>' +
            __giftProgressSvgSwap +
            '<span>' + (opts.selectGift ? 'Select Gift' : 'Change Gift') + '</span>' +
            '</button>'
          : '';
        var footer = (moreInfo || changeGift)
          ? '<div class="PBFCM-minicart-gift-progress__ab-gift-footer' +
            (moreInfo && changeGift ? ' is-split' : '') + '">' +
            moreInfo +
            (moreInfo && changeGift
              ? '<span class="PBFCM-minicart-gift-progress__ab-gift-sep" aria-hidden="true"></span>'
              : '') +
            changeGift +
            '</div>'
          : '';
        var selectAttr = opts.isChoice && variantId
          ? ' role="option" aria-selected="' + (opts.selected ? 'true' : 'false') +
            '" tabindex="0" data-gwp-swap-option="' + this.escapeGiftCardAttr(variantId) + '"'
          : '';

        var busyHtml = opts.busy
          ? '<div class="PBFCM-minicart-gift-progress__ab-gift-loading" aria-hidden="true">' +
            '<span class="PBFCM-minicart-gift-progress__ab-gift-spinner"></span>' +
            '</div>'
          : '';

        return '' +
          '<div class="PBFCM-minicart-gift-progress__ab-gift-card' +
            (opts.selected ? ' is-selected' : '') +
            (opts.isChoice ? ' is-choice' : '') +
            (opts.busy ? ' is-busy' : '') + '"' +
            (opts.busy ? ' aria-busy="true"' : '') +
            (variantId ? ' data-gift-variant-id="' + this.escapeGiftCardAttr(variantId) + '"' : '') +
            selectAttr + '>' +
            '<div class="PBFCM-minicart-gift-progress__ab-gift-details">' +
              '<div class="PBFCM-minicart-gift-progress__ab-gift-media" aria-hidden="true">' + imageHtml + '</div>' +
              badgeHtml +
              '<div class="PBFCM-minicart-gift-progress__ab-gift-text">' +
                '<span class="PBFCM-minicart-gift-progress__ab-gift-title">' + title + '</span>' +
                (desc ? '<span class="PBFCM-minicart-gift-progress__ab-gift-desc">' + desc + '</span>' : '') +
              '</div>' +
            '</div>' +
            footer +
            busyHtml +
          '</div>';
      },

      resolveDisplayedSwapId(inst, swapPool) {
        if (inst && inst.pendingSwapId && (!swapPool || !inst.pendingSwapPoolKey || inst.pendingSwapPoolKey === swapPool.key)) {
          return String(inst.pendingSwapId);
        }
        if (!swapPool) return '';
        return String(this.parseVariantIdFromGid(swapPool.selectedVariantId) || '');
      },

      getSwapPools(inst) {
        if (!window.FDCartGwp || typeof window.FDCartGwp.getSwapPools !== 'function') return [];
        var cart = inst.lastCart
          || (window.FDCart && typeof window.FDCart.getCurrentCart === 'function' && window.FDCart.getCurrentCart());
        if (!cart) return [];
        return window.FDCartGwp.getSwapPools(cart) || [];
      },

      getCollectionGiftGroups(inst) {
        return this.getSwapPools(inst).filter(function (pool) {
          return pool && pool.type === 'collectionCheck';
        });
      },

      giftDisplayQuantity(inst, group, variantId) {
        var id = variantId ? String(variantId) : '';
        var items = inst && inst.lastCart && inst.lastCart.items ? inst.lastCart.items : [];
        var line = items.filter(function (item) {
          var props = item && item.properties ? item.properties : {};
          return String(item.variant_id) === id && props._upsell_module === 'checkout_gwp';
        })[0];
        if (line && line.quantity >= 2) return line.quantity;
        var gifts = (group && group.gifts) || [];
        var gift = gifts.filter(function (entry) {
          return String(this.parseVariantIdFromGid(entry.giftVariantId)) === id;
        }, this)[0];
        if (gift && gift.quantity >= 2) return gift.quantity;
        return 1;
      },

      getActiveSwapPool(inst) {
        var groups = this.getCollectionGiftGroups(inst);
        if (groups.length) {
          if (inst.swapOpenKey) {
            var open = groups.filter(function (pool) { return pool.key === inst.swapOpenKey; })[0];
            if (open) return open;
          }
          return groups[0];
        }
        return this.getSwapPools(inst)[0] || null;
      },

      findSwapPool(inst, poolKey, variantId) {
        var pools = this.getSwapPools(inst);
        if (poolKey) {
          var exact = pools.filter(function (pool) { return pool.key === poolKey; })[0];
          if (exact) return exact;
        }
        var id = variantId ? String(variantId) : '';
        return pools.filter(function (pool) {
          var choices = pool.swapChoices && pool.swapChoices.length ? pool.swapChoices : pool.gifts;
          return (choices || []).some(function (gift) {
            return String(this.parseVariantIdFromGid(gift.giftVariantId)) === id;
          }, this);
        }, this)[0] || null;
      },

      collectPoolGifts(pool) {
        var gifts = [];
        var seen = {};
        (pool.gifts || []).concat(pool.swapChoices || []).forEach(function (gift) {
          var id = gift && gift.giftVariantId;
          if (!id || seen[id]) return;
          seen[id] = true;
          gifts.push(gift);
        });
        return gifts;
      },

      ensureSwapCards(inst, pool) {
        if (!pool) return;
        var gifts = this.collectPoolGifts(pool);
        if (!gifts.length) return;
        var key = JSON.stringify(gifts);
        if (pool.key && inst.groupCardsKey[pool.key] === key && inst.groupCards[pool.key]) {
          inst.swapCards = inst.groupCards[pool.key];
          inst.swapCardsKey = key;
          return;
        }
        if (!pool.key && inst.swapCardsKey === key && inst.swapCards && inst.swapCards.length) return;
        inst.swapCardsKey = key;
        if (pool.key) inst.groupCardsKey[pool.key] = key;
        var self = this;
        Promise.all(gifts.map(function (gift) {
          var variantId = self.parseVariantIdFromGid(gift.giftVariantId);
          var existing = (inst.giftCards || []).find(function (card) {
            return String(card.variantId) === String(variantId);
          });
          if (existing) {
            var reused = Object.assign({}, existing, {
              variantId: variantId,
              giftLabel: gift.giftLabel,
              giftDescription: gift.giftDescription || ''
            });
            self.hydrateGiftCard(inst, reused);
            return Promise.resolve(reused);
          }
          return self.resolveTierGiftCard({ giftVariant: gift.giftVariantId }, {}).then(function (card) {
            card.variantId = variantId;
            card.giftLabel = gift.giftLabel;
            card.giftDescription = gift.giftDescription || '';
            self.hydrateGiftCard(inst, card);
            return card;
          });
        })).then(function (cards) {
          inst.swapCards = cards;
          if (pool.key) inst.groupCards[pool.key] = cards;
          inst.giftCardsVersion += 1;
          self.renderAbGiftCards(inst, inst.lastSaleCartTotal || 0);
        });
      },

      handleChangeGiftClick(inst, variantId, poolKey) {
        if (inst.swapBusy) return;
        var pool = this.findSwapPool(inst, poolKey, variantId) || this.getActiveSwapPool(inst);
        if (!pool || !this.hasGiftReplacement(inst, pool, variantId)) return;
        this.ensureSwapCards(inst, pool);
        var nextKey = pool.key || '';
        var nextFrom = variantId ? String(variantId) : '';
        var willOpen = inst.swapOpenKey !== nextKey || inst.swapFromId !== nextFrom;
        inst.swapOpenKey = willOpen ? nextKey : '';
        inst.swapFromId = willOpen ? nextFrom : '';
        inst.swapOpen = !!inst.swapOpenKey;
        inst.lastGiftsHtml = null;
        this.renderAbGiftCards(inst, inst.lastSaleCartTotal || 0);
      },

      handleSwapSelect(inst, variantId, poolKey, fromVariantId) {
        if (!variantId || inst.swapBusy) return;
        var pool = this.findSwapPool(inst, poolKey, variantId) || this.getActiveSwapPool(inst);
        var fromId = fromVariantId || inst.swapFromId || this.resolveDisplayedSwapId(inst, pool);
        if (String(fromId) === String(variantId)) {
          inst.swapOpen = false;
          inst.swapOpenKey = '';
          inst.swapFromId = '';
          inst.lastGiftsHtml = null;
          this.renderAbGiftCards(inst, inst.lastSaleCartTotal || 0);
          return;
        }
        if (this.cartHasVariant(inst, variantId)) {
          inst.swapOpen = false;
          inst.swapOpenKey = '';
          inst.swapFromId = '';
          inst.lastGiftsHtml = null;
          this.renderAbGiftCards(inst, inst.lastSaleCartTotal || 0);
          return;
        }
        if (!window.FDCartGwp || typeof window.FDCartGwp.swapGift !== 'function') return;

        inst.swapBusy = true;
        inst.pendingSwapId = String(variantId);
        inst.pendingSwapFromId = fromId ? String(fromId) : '';
        inst.pendingSwapPoolKey = pool && pool.key ? pool.key : (poolKey || '');
        inst.lastGiftsHtml = null;
        this.renderAbGiftCards(inst, inst.lastSaleCartTotal || 0);

        var self = this;
        var started = Date.now();
        window.FDCartGwp.swapGift(variantId, inst.pendingSwapPoolKey, inst.pendingSwapFromId).then(function (cart) {
          if (cart) inst.lastCart = cart;
          self.finishSwapSelect(inst, started, true);
        }).catch(function () {
          inst.pendingSwapId = null;
          inst.pendingSwapFromId = '';
          inst.pendingSwapPoolKey = '';
          self.finishSwapSelect(inst, started, false);
        });
      },

      finishSwapSelect(inst, started, closeDropdown) {
        var self = this;
        var wait = Math.max(0, 480 - (Date.now() - started));
        window.setTimeout(function () {
          inst.swapBusy = false;
          inst.pendingSwapId = null;
          inst.pendingSwapFromId = '';
          inst.pendingSwapPoolKey = '';
          if (closeDropdown) {
            inst.swapOpen = false;
            inst.swapOpenKey = '';
            inst.swapFromId = '';
          }
          inst.lastGiftsHtml = null;
          self.renderAbGiftCards(inst, inst.lastSaleCartTotal || 0);
        }, wait);
      },

      bindGiftCardActions(inst) {
        if (inst._giftActionsBound || !inst.abGiftsHost) return;
        inst._giftActionsBound = true;
        var self = this;
        inst.abGiftsHost.addEventListener('click', function (event) {
          if (inst.swapBusy && !event.target.closest('[data-gwp-change-gift]')) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          var changeBtn = event.target.closest('[data-gwp-change-gift]');
          var option = event.target.closest('[data-gwp-swap-option]');
          if (changeBtn) {
            event.preventDefault();
            event.stopPropagation();
            self.handleChangeGiftClick(
              inst,
              changeBtn.getAttribute('data-gwp-change-gift'),
              changeBtn.getAttribute('data-gwp-swap-pool')
            );
            return;
          }
          if (option) {
            event.preventDefault();
            event.stopPropagation();
            self.handleSwapSelect(
              inst,
              option.getAttribute('data-gwp-swap-option'),
              option.getAttribute('data-gwp-swap-pool'),
              option.getAttribute('data-gwp-swap-from')
            );
          }
        });
      },

      cardsForVariantIds(cards, variantIds) {
        var wanted = {};
        (variantIds || []).forEach(function (id) { wanted[String(id)] = true; });
        return (cards || []).filter(function (card) {
          return card && wanted[String(card.variantId)];
        });
      },

      groupHasSelectedGift(inst, group) {
        var selected = this.parseVariantIdFromGid(group && group.selectedVariantId);
        if (selected && this.cartHasVariant(inst, selected)) return true;
        return ((group && group.gifts) || []).some(function (gift) {
          return this.cartHasVariant(inst, this.parseVariantIdFromGid(gift.giftVariantId));
        }, this);
      },

      displayIdsForGroup(inst, group) {
        var ids = (group.gifts || []).map(function (gift) {
          return String(this.parseVariantIdFromGid(gift.giftVariantId) || '');
        }, this).filter(Boolean);
        if (
          inst.pendingSwapId &&
          inst.pendingSwapPoolKey &&
          inst.pendingSwapPoolKey === group.key &&
          inst.pendingSwapFromId
        ) {
          return ids.map(function (id) {
            return id === String(inst.pendingSwapFromId) ? String(inst.pendingSwapId) : id;
          });
        }
        return ids;
      },

      cartHasVariant(inst, variantId) {
        if (!variantId || !inst || !inst.lastCart || !inst.lastCart.items) return false;
        var id = String(variantId);
        return inst.lastCart.items.some(function (item) {
          return String(item.variant_id || item.id) === id;
        });
      },

      availableSwapChoiceIds(inst, pool, currentId) {
        var self = this;
        var current = currentId ? String(currentId) : '';
        var choices = pool.swapChoices && pool.swapChoices.length ? pool.swapChoices : pool.gifts || [];
        return choices
          .filter(function (choice) {
            if (!pool.exclusive) return true;
            return (choice.components || [choice]).every(function (gift) {
              var id = String(self.parseVariantIdFromGid(gift.giftVariantId));
              return !(inst.lastCart && inst.lastCart.items || []).some(function (line) {
                if (String(line.variant_id) !== id) return false;
                var props = line.properties || {};
                var protectedGift = [props._bundle_gift, props._box_picker_gift, props._welcome_kit_gift]
                  .some(function (value) { return value === true || value === 'true'; }) || props._upsell_module === 'build_box';
                return protectedGift || props._upsell_module !== 'checkout_gwp' ||
                  String(props._discount_code_source || '').toLowerCase() !== String(pool.discountCode || '').toLowerCase();
              });
            });
          })
          .map(function (gift) {
            return String(self.parseVariantIdFromGid(gift.giftVariantId) || '');
          })
          .filter(Boolean)
          .filter(function (id) {
            return pool.exclusive || id === current || !self.cartHasVariant(inst, id);
          });
      },

      hasGiftReplacement(inst, pool, currentId) {
        if (!pool || !currentId) return false;
        var current = String(currentId);
        return this.availableSwapChoiceIds(inst, pool, current).some(function (id) {
          return id !== current;
        });
      },

      renderSwapDropdownHtml(inst, pool, cards, displayedId) {
        var choiceIds = this.availableSwapChoiceIds(inst, pool, displayedId);
        var options = this.cardsForVariantIds(cards, choiceIds);
        if (!options.length) options = cards || [];
        var fromId = inst.swapFromId || displayedId || '';
        var headingHtml = displayedId
          ? '<h3 class="PBFCM-minicart-gift-progress__ab-gift-swap-heading">' +
            this.escapeGiftCardAttr(this.swapGiftHeading) + '</h3>'
          : '';
        return '<div class="PBFCM-minicart-gift-progress__ab-gift-dropdown">' +
          headingHtml +
          '<div class="PBFCM-minicart-gift-progress__ab-gift-options' +
          (options.length > 2 ? ' is-scrollable' : '') + '" role="listbox" aria-label="' +
          this.escapeGiftCardAttr(this.swapGiftHeading) + '">' +
          options.map(function (card) {
            this.hydrateGiftCard(inst, card);
            var variantId = card.variantId ? String(card.variantId) : '';
            var selected = !!(displayedId && variantId === displayedId);
            var imageHtml = card.imageUrl
              ? '<img src="' + card.imageUrl + '" alt="" loading="lazy" width="44" height="44">'
              : '';
            var statusHtml = selected && inst.swapBusy
              ? '<span class="PBFCM-minicart-gift-progress__ab-gift-spinner is-inline" aria-hidden="true"></span>'
              : '';
            return '' +
              '<button type="button" class="PBFCM-minicart-gift-progress__ab-gift-option' +
                (selected ? ' is-selected' : '') +
                (inst.swapBusy ? ' is-disabled' : '') + '"' +
                (variantId ? ' data-gwp-swap-option="' + this.escapeGiftCardAttr(variantId) + '"' : '') +
                (pool.key ? ' data-gwp-swap-pool="' + this.escapeGiftCardAttr(pool.key) + '"' : '') +
                (fromId ? ' data-gwp-swap-from="' + this.escapeGiftCardAttr(fromId) + '"' : '') +
                (inst.swapBusy ? ' disabled' : '') +
                ' role="option" aria-selected="' + (selected ? 'true' : 'false') + '">' +
                '<span class="PBFCM-minicart-gift-progress__ab-gift-option-media">' + imageHtml + '</span>' +
                '<span class="PBFCM-minicart-gift-progress__ab-gift-option-title">' +
                  (this.realGiftLabel(card.giftLabel)
                    || this.displayGiftTitle(card.title, this.giftDisplayQuantity(inst, pool, variantId))) +
                '</span>' +
                (selected
                  ? '<span class="PBFCM-minicart-gift-progress__ab-gift-selected-label">' +
                    this.escapeGiftCardAttr(this.selectedGiftLabel) + '</span>'
                  : '') +
                statusHtml +
              '</button>';
          }, this).join('') +
          '</div></div>';
      },

      clearAbGiftCards(inst) {
        if (inst.abGiftsHost && inst.lastGiftsHtml !== '') {
          inst.abGiftsHost.innerHTML = '';
          inst.lastGiftsHtml = '';
        }
        inst.root.classList.add('has-no-gift-cards');
        inst.root.classList.remove('has-multi-gifts', 'is-swap-open', 'is-swap-busy');
      },

      renderAbGiftCards(inst, saleCartTotal) {
        if (!inst.abGiftsHost) return;
        inst.root.classList.toggle('is-swap-busy', !!inst.swapBusy);
        inst.abGiftsHost.setAttribute('aria-busy', inst.swapBusy ? 'true' : 'false');
        inst.abGiftsHost.toggleAttribute('inert', !!inst.swapBusy);
        // Keep the current layout under the loader until the complete swap settles.
        if (inst.swapBusy) return;

        var groups = this.getCollectionGiftGroups(inst);
        if (!groups.length && window.FDCartGwp && window.FDCartGwp.hasExclusiveCollectionChecks &&
          window.FDCartGwp.hasExclusiveCollectionChecks(inst.lastCart)) {
          this.clearAbGiftCards(inst);
          return;
        }
        if ((!inst.giftCards || !inst.giftCards.length) && !groups.length) {
          this.clearAbGiftCards(inst);
          return;
        }

        var max = inst.abTiers.length ? inst.abTiers[inst.abTiers.length - 1].thresholdCents : 0;
        var allUnlocked = max > 0 && saleCartTotal >= max;
        var visibleCards = [];
        var descCards = inst.giftCards || [];
        var html = '';

        if (groups.length) {
          groups.forEach(function (group) { this.ensureSwapCards(inst, group); }, this);
          var seenVariant = {};
          var groupBlocks = groups.map(function (group) {
              var cards = inst.groupCards[group.key] || inst.swapCards || [];
              var displayedId = inst.swapFromId
                || this.resolveDisplayedSwapId(inst, group);
              var pickFirstEmpty = !!(group.requireUserChoice && !this.groupHasSelectedGift(inst, group));
              var displayIds = (pickFirstEmpty ? [] : this.displayIdsForGroup(inst, group)).filter(function (id) {
                if (seenVariant[id]) return false;
                seenVariant[id] = true;
                return true;
              });
              var cardsForGroup = this.cardsForVariantIds(cards, displayIds);
              var groupBusy = !!(inst.swapBusy && inst.pendingSwapPoolKey === group.key);
              if (pickFirstEmpty) {
                if (!cards.length) return '';
                var chooseLabel = this.chooseGiftLabel;
                var pickHtml =
                  '<div class="PBFCM-minicart-gift-progress__ab-gift-card is-pick-first' +
                    (groupBusy ? ' is-busy' : '') + '"' +
                    ' aria-label="' + this.escapeGiftCardAttr(chooseLabel) + '"' +
                    (groupBusy ? ' aria-busy="true"' : '') + '>' +
                    '<span class="PBFCM-minicart-gift-progress__ab-gift-pick-label">' +
                    this.escapeGiftCardAttr(chooseLabel) +
                    '</span>' +
                    this.renderSwapDropdownHtml(inst, group, cards, '') +
                    (groupBusy
                      ? '<div class="PBFCM-minicart-gift-progress__ab-gift-loading" aria-hidden="true">' +
                        '<span class="PBFCM-minicart-gift-progress__ab-gift-spinner"></span></div>'
                      : '') +
                  '</div>';
                return '<div class="PBFCM-minicart-gift-progress__ab-gift-group">' + pickHtml + '</div>';
              }
              if (!cardsForGroup.length) return '';
              var cardHtml = cardsForGroup.map(function (card) {
                this.hydrateGiftCard(inst, card);
                var cardId = card.variantId ? String(card.variantId) : '';
                var canSwap = this.hasGiftReplacement(inst, group, cardId);
                var html = this.renderGiftCardHtml(card, {
                  swappable: canSwap,
                  showBadge: true,
                  selected: !!(displayedId && cardId === displayedId),
                  busy: !!(groupBusy && inst.pendingSwapFromId && inst.pendingSwapFromId === cardId),
                  poolKey: group.key,
                  quantity: this.giftDisplayQuantity(inst, group, cardId),
                  selectGift: !!(group.requireUserChoice && !cardId)
                });
                if (canSwap && inst.swapOpenKey === group.key && displayedId && cardId === displayedId) {
                  html += this.renderSwapDropdownHtml(inst, group, cards, displayedId);
                }
                return html;
              }, this).join('');
              descCards = descCards.concat(cards);
              return '<div class="PBFCM-minicart-gift-progress__ab-gift-group">' + cardHtml + '</div>';
            }, this).filter(Boolean);
          if (groupBlocks.length) {
            html = '<div class="PBFCM-minicart-gift-progress__ab-gift-stack">' + groupBlocks.join('') + '</div>';
          }
        } else {
          var swapPool = this.getActiveSwapPool(inst);
          if (swapPool) this.ensureSwapCards(inst, swapPool);

          if (swapPool && inst.swapCards && inst.swapCards.length) {
            var selectedId = this.resolveDisplayedSwapId(inst, swapPool);
            var selectedCard = inst.swapCards.filter(function (card) {
              return String(card.variantId) === String(selectedId);
            })[0];
            visibleCards = selectedCard ? [selectedCard] : inst.swapCards.slice(0, 1);
          } else if (allUnlocked && inst.giftCards && inst.giftCards.length) {
            visibleCards = inst.giftCards;
          }

          if (visibleCards.length) {
            var displayedId = this.resolveDisplayedSwapId(inst, swapPool);
            var cardHtml = visibleCards.map(function (card) {
              this.hydrateGiftCard(inst, card);
              var selected = !!(displayedId && String(card.variantId) === displayedId);
              return this.renderGiftCardHtml(card, {
                swappable: this.hasGiftReplacement(inst, swapPool, card.variantId),
                showBadge: !!(swapPool || allUnlocked),
                selected: selected,
                busy: !!inst.swapBusy,
                poolKey: swapPool && swapPool.key
              });
            }, this).join('');

            var dropdownHtml = '';
            if (inst.swapOpen && this.hasGiftReplacement(inst, swapPool, displayedId) && inst.swapCards && inst.swapCards.length) {
              dropdownHtml = this.renderSwapDropdownHtml(inst, swapPool, inst.swapCards, displayedId);
            }

            html = '<div class="PBFCM-minicart-gift-progress__ab-gift-stack">' + cardHtml + dropdownHtml + '</div>';
            descCards = (inst.swapCards && inst.swapCards.length) ? inst.swapCards : visibleCards;
          }
        }

        var hasCards = html.indexOf('PBFCM-minicart-gift-progress__ab-gift-card') !== -1;
        if (!hasCards) {
          this.clearAbGiftCards(inst);
          return;
        }

        if (html !== inst.lastGiftsHtml) {
          inst.abGiftsHost.innerHTML = html;
          inst.lastGiftsHtml = html;
        }

        this.bindGiftCardActions(inst);
        inst.root.classList.remove('has-no-gift-cards');
        inst.root.classList.toggle('is-swap-open', !!inst.swapOpen);
        inst.root.classList.toggle('is-swap-busy', !!inst.swapBusy);
        inst.root.classList.toggle('has-multi-gifts', groups.length > 1);
        this.ensureGiftDescriptions(inst, descCards);

        if (allUnlocked && inst.abTiers.length > 1 && !inst.swapOpen) {
          this.bindGiftTrackDrag(inst);
        }
      },

      async buildAbGiftCards(inst, attempt) {
        if (!inst.abGiftsHost || !inst.abTiers.length) return;
        if (inst.abGiftsBuilt) return;

        attempt = attempt || 0;
        var fallback = {};
        var fallbackEl = inst.root.querySelector('[data-gift-default-product]');
        if (fallbackEl) {
          try { fallback = JSON.parse(fallbackEl.textContent || '{}'); } catch (e) {}
        }

        var self = this;
        var cards = await Promise.all(inst.abTiers.map(function (tier) {
          return self.resolveTierGiftCard(tier, fallback).then(function (card) {
            card.variantId = self.parseVariantIdFromGid(tier.giftVariant);
            return card;
          });
        }));

        var hasPlaceholder = cards.some(function (card) {
          return self.isPlaceholderGiftTitle(card.title);
        });

        if (hasPlaceholder && attempt < 3) {
          await self.waitForStorefront(2000);
          return self.buildAbGiftCards(inst, attempt + 1);
        }

        inst.giftCards = cards;
        cards.forEach(function (card) { self.hydrateGiftCard(inst, card); });
        inst.giftCardsVersion += 1;
        inst.abGiftsBuilt = true;
        this.renderAbGiftCards(inst, 0);
        this.applyTierLabelLinks(inst);
      },

      bindGiftTrackDrag(inst) {
        var track = inst.abGiftsHost;
        if (!track || track.dataset.giftDragBound === 'true') return;
        if (!inst.root.classList.contains('is-all-unlocked') || inst.abTiers.length <= 1) return;
        track.dataset.giftDragBound = 'true';

        var state = {
          active: false,
          moved: false,
          startX: 0,
          startScroll: 0,
          pointerId: null
        };

        function canScroll() {
          return track.scrollWidth > track.clientWidth + 1;
        }

        function endDrag() {
          if (!state.active) return;
          state.active = false;
          track.classList.remove('is-dragging');
          if (track.releasePointerCapture && state.pointerId != null) {
            try { track.releasePointerCapture(state.pointerId); } catch (e) {}
          }
          state.pointerId = null;
          window.setTimeout(function () { state.moved = false; }, 0);
        }

        track.addEventListener('pointerdown', function (event) {
          if (!canScroll()) return;
          if (event.pointerType === 'mouse' && event.button !== 0) return;

          state.active = true;
          state.moved = false;
          state.startX = event.clientX;
          state.startScroll = track.scrollLeft;
          state.pointerId = event.pointerId;
          track.classList.add('is-dragging');
          if (track.setPointerCapture) track.setPointerCapture(event.pointerId);
        });

        track.addEventListener('pointermove', function (event) {
          if (!state.active) return;
          var delta = event.clientX - state.startX;
          if (Math.abs(delta) > 3) state.moved = true;
          track.scrollLeft = state.startScroll - delta;
          event.preventDefault();
        });

        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);
        track.addEventListener('lostpointercapture', endDrag);

        track.addEventListener('click', function (event) {
          if (state.moved) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, true);

        track.addEventListener('dragstart', function (event) {
          event.preventDefault();
        });
      },

      formatTierDollars(cents) {
        var dollars = (parseInt(cents, 10) || 0) / 100;
        return Number.isInteger(dollars) ? dollars : dollars.toFixed(2);
      },

      ensureGiftDescriptions(inst, cards) {
        var self = this;
        var pending = (cards || []).filter(function (card) {
          return card && !card.description && (card.handle || card.title) && !card._descFetch;
        });
        if (!pending.length) return;
        pending.forEach(function (card) { card._descFetch = true; });
        Promise.all(pending.map(function (card) {
          var handle = card.handle || self.slugifyGiftTitle(card.title);
          return self.fetchProductJson(handle).then(function (product) {
            if (!product) return;
            if (product.handle) card.handle = product.handle;
            card.description = self.shortGiftDescription(self.rawProductDescription(product));
            if (product.featured_image) {
              card.imageUrl = self.sizeGiftImageUrl(product.featured_image) || card.imageUrl;
            }
          });
        })).then(function () {
          inst.lastGiftsHtml = null;
          self.renderAbGiftCards(inst, inst.lastSaleCartTotal || 0);
        });
      },

      buildTierLabelHtml(dollarsLabel, card, singleTier) {
        var handle = (card && card.handle) || '';
        var tagName = handle ? 'button' : 'span';
        var attrs = '';
        if (handle) {
          attrs =
            ' type="button"' +
            ' data-info-modal-open="' + this.escapeGiftCardAttr(handle) + '"' +
            ' aria-label="More info about ' + this.escapeGiftCardAttr(card.title || 'Free Gift') + '"';
        }
        var amount = '<span class="PBFCM-minicart-gift-progress__ab-tier-label-part">$' + dollarsLabel + '</span>';
        var prefix = singleTier
          ? ''
          : '<span class="PBFCM-minicart-gift-progress__ab-tier-label-part">Free Gift</span>' +
            '<span class="PBFCM-minicart-gift-progress__ab-tier-label-sep" aria-hidden="true">|</span>';
        return (
          '<' + tagName + ' class="PBFCM-minicart-gift-progress__ab-tier-label' + (handle ? ' is-clickable' : '') + '"' + attrs + '>' +
            prefix + amount +
          '</' + tagName + '>'
        );
      },

      buildAbTierMarkers(inst) {
        if (inst.abTiersBuilt || !inst.abTiersHost || !inst.abTiers.length) return;

        inst.abTiersHost.innerHTML = inst.abTiers.map(function (tier, index) {
          var dollarsLabel = this.formatTierDollars(tier.thresholdCents);
          var card = inst.giftCards && inst.giftCards[index];
          return (
            '<div class="PBFCM-minicart-gift-progress__ab-tier" data-tier-index="' + index + '" data-threshold-cents="' + tier.thresholdCents + '" data-gift-value="' + tier.giftValue + '"' + (tier.giftVariant ? ' data-gift-variant="' + tier.giftVariant + '"' : '') + '>' +
              '<div class="PBFCM-minicart-gift-progress__ab-tier-dot">' + __giftProgressSvgLock + '</div>' +
              this.buildTierLabelHtml(dollarsLabel, card, inst.abTiers.length <= 1) +
            '</div>'
          );
        }.bind(this)).join('');

        inst.abTierEls = Array.prototype.slice.call(inst.abTiersHost.querySelectorAll('.PBFCM-minicart-gift-progress__ab-tier'));
        inst.abTiersBuilt = true;
        this.layoutTierColumns(inst);
      },

      // Tier markers render before the gift products resolve, so upgrade the
      // plain labels into info-modal triggers once each tier's card is known.
      applyTierLabelLinks(inst) {
        if (!inst.abTierEls || !inst.abTierEls.length) return;
        if (!inst.giftCards || !inst.giftCards.length) return;

        inst.abTierEls.forEach(function (tierEl, index) {
          var card = inst.giftCards[index];
          if (!card || !card.handle) return;

          var label = tierEl.querySelector('.PBFCM-minicart-gift-progress__ab-tier-label');
          if (!label || label.tagName === 'BUTTON') return;

          var dollarsLabel = this.formatTierDollars(tierEl.getAttribute('data-threshold-cents'));
          label.outerHTML = this.buildTierLabelHtml(dollarsLabel, card, inst.abTiers.length <= 1);
          inst.dotRatiosDirty = true;
        }, this);
      },

      isAbTierCurrent(inst, saleCartTotal) {
        return inst.abTiersBuilt &&
          inst.renderedSaleCartTotal === saleCartTotal &&
          inst.renderedGiftCardsVersion === inst.giftCardsVersion &&
          !this.needsTierDotMeasure(inst, saleCartTotal);
      },

      updateAbTier(inst, saleCartTotal, stateOnly) {
        if (!this.isAbTire(inst.root) || !inst.abTiers.length) return;
        var nextTierEl = null;

        if (stateOnly) {
          for (var i = 0; i < inst.abTierEls.length; i++) {
            var cents = parseInt(inst.abTierEls[i].getAttribute('data-threshold-cents') || '0', 10) || 0;
            if (saleCartTotal < cents) {
              nextTierEl = inst.abTierEls[i];
              break;
            }
          }
        } else {
          this.buildAbTierMarkers(inst);
          this.applyTierLabelLinks(inst);
          var minThreshold = inst.abTiers[0].thresholdCents;
          var max = inst.abTiers[inst.abTiers.length - 1].thresholdCents;
          var tierDotRatios = saleCartTotal > 0 && saleCartTotal < max
            ? this.buildTierDotRatios(inst, minThreshold, max)
            : null;
          var fillRatio = this.getFillBarRatio(saleCartTotal, inst.abTiers, minThreshold, max, tierDotRatios);
          var fillWidth = (fillRatio * 100) + '%';
          if (inst.abFill && fillWidth !== inst.lastAbFillWidth) {
            inst.abFill.style.width = fillWidth;
            inst.lastAbFillWidth = fillWidth;
          }

          inst.abTierEls.forEach(function (tierEl) {
            var tCents = parseInt(tierEl.getAttribute('data-threshold-cents') || '0', 10) || 0;
            var thresholdReached = saleCartTotal >= tCents;
            var dot = tierEl.querySelector('.PBFCM-minicart-gift-progress__ab-tier-dot');
            if (dot && dot.classList.contains('is-reached') !== thresholdReached) {
              dot.classList.toggle('is-reached', thresholdReached);
              dot.innerHTML = thresholdReached ? __giftProgressSvgCheck : __giftProgressSvgLock;
            }
            if (!thresholdReached && !nextTierEl) nextTierEl = tierEl;
          });

          this.renderAbGiftCards(inst, saleCartTotal);
          inst.renderedSaleCartTotal = saleCartTotal;
          inst.renderedGiftCardsVersion = inst.giftCardsVersion;
        }

        if (!inst.abHeadline) return;
        if (!nextTierEl) {
          inst.root.classList.add('is-all-unlocked');
          inst.root.classList.add('is-ab-expanded');
          if (inst.abTiers.length > 1) this.bindGiftTrackDrag(inst);
          var collectionGiftCount = 0;
          this.getCollectionGiftGroups(inst).forEach(function (group) {
            collectionGiftCount += (group.gifts || []).length;
          });
          var unlockedText = inst.abTiers.length > 1 || collectionGiftCount > 1
            ? '🎉 All Gifts Unlocked'
            : '🎉 Gift Unlocked';
          if (inst.lastHeadline !== 'text:' + unlockedText) {
            inst.abHeadline.textContent = unlockedText;
            inst.lastHeadline = 'text:' + unlockedText;
          }
          if (inst.abToggle) {
            inst.abToggle.setAttribute('aria-expanded', 'true');
          }
          return;
        }
        inst.root.classList.remove('is-all-unlocked');
        var remaining = Math.max(0, parseInt(nextTierEl.getAttribute('data-threshold-cents') || '0', 10) - saleCartTotal);
        var giftValue = nextTierEl.getAttribute('data-gift-value') || '25';
        var headlineHtml = '<strong>$' + (remaining / 100).toFixed(2) + '</strong> away from a FREE $' + giftValue + ' GIFT!';
        if (inst.lastHeadline !== 'html:' + headlineHtml) {
          inst.abHeadline.innerHTML = headlineHtml;
          inst.lastHeadline = 'html:' + headlineHtml;
        }
      },

      async resolveCartTotals(inst, cartOverride) {
        try {
          // cartOverride: the predicted cart of a drawer action still on its way.
          var cart = cartOverride || null;
          if (!cart && typeof window.FDCartApi !== 'undefined' && window.FDCartApi.getCart) {
            cart = await window.FDCartApi.getCart();
          } else if (!cart) {
            var response = await fetch('/cart.js', {
              headers: { Accept: 'application/json' },
              credentials: 'same-origin'
            });
            cart = await response.json();
          }

          if (inst && cart) inst.lastCart = cart;

          if (!cart || !cart.item_count) {
            return { salePriceTotal: 0, compareAtTotal: 0 };
          }

          if (typeof window.calculateGiftProgressTotals === 'function') {
            return window.calculateGiftProgressTotals(cart);
          }

          return window.calculateCartTotalsFromElements
            ? window.calculateCartTotalsFromElements()
            : { salePriceTotal: 0, compareAtTotal: 0 };
        } catch (error) {
          console.error('PBFCM gift progress: cart total failed', error);
          return { salePriceTotal: 0, compareAtTotal: 0 };
        }
      },

      async updateInstance(inst, cartOverride) {
        try {
          var totals = await this.resolveCartTotals(inst, cartOverride);
          if (cartOverride && cartOverride.items) inst.lastCart = cartOverride;
          else if (window.FDCart && typeof window.FDCart.getCurrentCart === 'function') {
            inst.lastCart = window.FDCart.getCurrentCart() || inst.lastCart;
          }
          var saleCartTotal = totals.salePriceTotal || 0;
          var originalCartTotal = totals.compareAtTotal || 0;

          if (saleCartTotal === inst.lastSaleCartTotal && this.isAbTierCurrent(inst, saleCartTotal)) {
            this.updateAbTier(inst, saleCartTotal, true);
            return;
          }

          this.updateAbTier(inst, saleCartTotal);
          inst.lastSaleCartTotal = saleCartTotal;
          if (!inst.progressBar) return;

          var legacyThreshold = inst.legacyThreshold || inst.threshold;
          var percentage = Math.min((saleCartTotal / legacyThreshold) * 100, 100);
          inst.progressBar.style.width = percentage + '%';

          var wrapper = inst.progressBar.closest('.PBFCM-minicart-gift-progress__bar-wrapper');
          if (wrapper) {
            var currentDollars = Math.round(saleCartTotal / 100);
            var thresholdDollars = legacyThreshold / 100;
            wrapper.setAttribute('aria-valuenow', currentDollars);
            wrapper.setAttribute('aria-valuetext',
              percentage >= 100
                ? 'Free gift unlocked!'
                : currentDollars + ' of ' + thresholdDollars + ' dollars spent towards free gift'
            );
          }

          if (inst.tooltip) {
            if (saleCartTotal === 0 || percentage >= 100) {
              inst.tooltip.style.display = 'none';
            } else {
              inst.tooltip.style.display = 'flex';
              var saleDollars = (saleCartTotal / 100).toFixed(2);
              var origDollars = (originalCartTotal / 100).toFixed(2);
              if (inst.tooltipSalePrice) inst.tooltipSalePrice.textContent = '$' + saleDollars;
              if (inst.tooltipOrigPrice) {
                if (Number(origDollars) > Number(saleDollars)) {
                  inst.tooltipOrigPrice.textContent = '$' + origDollars;
                  inst.tooltipOrigPrice.style.display = '';
                } else {
                  inst.tooltipOrigPrice.textContent = '';
                  inst.tooltipOrigPrice.style.display = 'none';
                }
              }
            }
          }

          if (inst.statusText) {
            if (percentage >= 100) {
              var wasComplete = inst.bottomContainer && inst.bottomContainer.classList.contains('PBFCM-minicart-gift-progress__bottom--complete');
              inst.statusText.textContent = this.statusComplete;
              if (inst.tooltip) inst.tooltip.style.display = 'none';
              if (inst.bottomContainer) inst.bottomContainer.classList.add('PBFCM-minicart-gift-progress__bottom--complete');
              if (inst.cardContainer) inst.cardContainer.classList.add('PBFCM-minicart-gift-progress__bottom--complete');
              if (inst.progressBar) inst.progressBar.classList.add('PBFCM-minicart-gift-progress__bar-fill--complete');
              if (inst.barMark) inst.barMark.classList.add('PBFCM-minicart-gift-progress__bar-mark--complete');
              if (!wasComplete && typeof window.announceToScreenReader === 'function') {
                window.announceToScreenReader('Congratulations! You have unlocked a free gift.');
              }
            } else {
              var remaining = Math.max(legacyThreshold - saleCartTotal, 0);
              inst.statusText.textContent = this.statusIncomplete.replace('{amount}', '$' + (remaining / 100).toFixed(2));
              if (inst.bottomContainer) inst.bottomContainer.classList.remove('PBFCM-minicart-gift-progress__bottom--complete');
              if (inst.cardContainer) inst.cardContainer.classList.remove('PBFCM-minicart-gift-progress__bottom--complete');
              if (inst.progressBar) inst.progressBar.classList.remove('PBFCM-minicart-gift-progress__bar-fill--complete');
              if (inst.barMark) inst.barMark.classList.remove('PBFCM-minicart-gift-progress__bar-mark--complete');
            }
          }
        } catch (error) {
          console.error('PBFCM gift progress update failed', error);
        }
      },

      updateAll(cartOverride) {
        var self = this;
        this.instances.forEach(function (inst) { self.updateInstance(inst, cartOverride); });
      },

      init() {
        var self = this;
        document.querySelectorAll('[data-component="PBFCM-minicart-gift-progress"]').forEach(function (root) {
          if (root.dataset.giftProgressReady === 'true') return;
          root.dataset.giftProgressReady = 'true';
          var inst = self.createInstance(root);
          if (inst.abToggle) {
            inst.abToggle.addEventListener('click', function () {
              var expanded = inst.abToggle.getAttribute('aria-expanded') === 'true';
              inst.root.classList.toggle('is-ab-expanded', !expanded);
              inst.abToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
            });
          }
          if (inst.progressBar || inst.abTiersHost) {
            self.instances.push(inst);
            self.buildAbGiftCards(inst);
          }
        });

        if (!this._listenersBound) {
          this._listenersBound = true;
          var updateFramePending = false;
          var scheduleUpdateAll = function () {
            if (updateFramePending) return;
            updateFramePending = true;
            requestAnimationFrame(function () {
              updateFramePending = false;
              self.updateAll();
            });
          };
          var markTierDotsDirty = function () {
            self.instances.forEach(function (inst) { inst.dotRatiosDirty = true; });
          };
          document.addEventListener('cart:updated', scheduleUpdateAll);
          document.addEventListener('ig:CartUpdated', scheduleUpdateAll);
          var resizeFramePending = false;
          window.addEventListener('resize', function () {
            markTierDotsDirty();
            if (resizeFramePending) return;
            resizeFramePending = true;
            requestAnimationFrame(function () {
              resizeFramePending = false;
              self.instances.forEach(function (inst) {
                self.updateAbTier(inst, inst.lastSaleCartTotal || 0);
              });
            });
          });
          if (document.fonts && document.fonts.addEventListener) {
            document.fonts.addEventListener('loadingdone', markTierDotsDirty);
          }
        }

        this.updateAll();
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { window.PBFCM_Minicart.giftProgress.init(); });
    } else {
      window.PBFCM_Minicart.giftProgress.init();
    }
  }
